import { OrderDirections } from '@sigmasms/shared-types'

import { buttonModes, components, icons, popperPlacements, sizes } from '@/utils'

import button from '@/components/button'
import tag from '@/components/tag'

/**
 * Иконки кнопок направления сортировки по значениям `OrderDirections`.
 *
 * @type {Record<string, string>}
 */
const directionIcons = {
  [OrderDirections.ASC]: icons.arrow_upward,
  [OrderDirections.DESC]: icons.arrow_downward
}

function renderActivator(h) {
  return h(
    button,
    {
      props: {
        icon: icons.sort,
        mode: buttonModes.flat,
        color: this.getActiveColor(this.hasOrderField),
        tooltip: this.getTranslate('buttons.order')
      },
      slot: 'activator'
    }
  )
}

function renderTitle(h) {
  return h(
    tag,
    {
      props: {
        label: this.getTranslate('buttons.order'),
        as: 'button',
        size: sizes.tiny
      }
    }
  )
}
function renderResetButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.reset'),
        mode: buttonModes.flat,
        size: sizes.tiny,
        disabled: this.isDefault
      },
      on: {
        click: () => {
          this.reset()
        }
      }
    }
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: 'button-order__header'
    },
    [
      renderTitle.call(this, h),
      renderResetButton.call(this, h)
    ]
  )
}
function renderFieldSelect(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.orderField,
        label: this.getTranslate('order.labels.field'),
        items: this.fieldItems,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          this.setOrderField(event)
        }
      }
    }
  )
}
function renderDirectionButton(h, { title, value }) {
  return h(
    button,
    {
      props: {
        icon: directionIcons[value],
        mode: buttonModes.flat,
        color: this.getActiveColor(this.isCurrentDirection(value)),
        pressed: this.isCurrentDirection(value),
        disabled: !this.hasOrderField,
        tooltip: title
      },
      on: {
        click: () => {
          this.setOrderDirection(value)
        }
      }
    }
  )
}
function renderFields(h) {
  return h(
    'div',
    {
      class: 'button-order__fields'
    },
    [
      renderFieldSelect.call(this, h),
      ...this.directionItems.map(item => {
        return renderDirectionButton.call(this, h, item)
      })
    ]
  )
}
function renderContent(h) {
  return h(
    'div',
    {
      class: 'button-order__content'
    },
    [
      renderHeader.call(this, h),
      renderFields.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components.menu,
    {
      props: {
        rounded: true,
        closeOnContentClick: false,
        placement: popperPlacements['bottom-start'],
        offsetDistance: 8
      }
    },
    [
      renderActivator.call(this, h),
      renderContent.call(this, h)
    ]
  )
}
